import React, { useEffect, useRef } from 'react';
import { AdMarketplaceSlotDivNames } from './ad-slots';
import { AdMarketplaceLoader } from './client-side/loader';
import './styles.scss';


export type AdMarketplaceAdsProps = {
    pageType: string | undefined;
    l1Category: string | undefined;
    device: string | undefined;
    currentPage: number | undefined;
    isZeroResults: boolean;
    query?: string;
    isQA?: boolean;
    resultsTa?: number;
    resultsPa?: number;
    locale?: string;
    style?: React.CSSProperties;
    slot: string;
};

const AdMarketplaceAds: React.FC<AdMarketplaceAdsProps> = ({
    slot,
    pageType,
    l1Category,
    device,
    currentPage,
    isZeroResults,
    query,
    resultsTa,
    resultsPa,
    locale,
    style,
    isQA,
}) => {
    const mountedRef = useRef(false);
    const getLastPathSegment = (): string | null => {
        if (typeof window === 'undefined') return null;
        const segments = window.location.pathname.split('/').filter(Boolean);
        if (segments.length === 0) return null;
        let last = segments[segments.length - 1];
        try {
            last = decodeURIComponent(last);
        } catch (_e) {
            // ignore
        }
        return last.replace(/\+/g, ' ').toLowerCase();
    };
    const getKeyword = () => {
        const lastPathSegment = getLastPathSegment();
        const l1CategoryVal = l1Category ? String(l1Category).toLowerCase() : '';
        const keyword = query || lastPathSegment || l1CategoryVal || 'for sale';
        // console.log('keyword------', query, lastPathSegment, l1CategoryVal, keyword);
        return keyword;
    }

    useEffect(() => {
        if (mountedRef.current) return;
        if (typeof window === 'undefined') return;
        const configDev = {
            'partnerName': 'gumtree',
            'plid': 'si9cfi1t68',
            'qt': 'shoes',
            resultsPa,
            'rfr': window.location.host,
        }
        const configProd = {
            'partnerName': 'gumtree',
            'plid': 'si9cfi1t68',
            'qt': getKeyword(),
            resultsPa,
            'rfr': window.location.href,
        }
        const config = isQA ? configDev : configProd;

        const loader = new AdMarketplaceLoader(config);
        loader.loadAds(config.qt, slot).catch((e) => console.error('AdMarketplace: load error', e));

        mountedRef.current = true;
    }, [pageType, l1Category, currentPage, device, isZeroResults, query, resultsTa, resultsPa, locale]);

    return (
        <div id={slot} className="admarketplace-root" style={{ minHeight: '250px', ...style }}>
            {/* <div id={AdMarketplaceSlotDivNames.textAdContainer} /> */}
            <div id={AdMarketplaceSlotDivNames.productAdContainer} />
        </div>
    );
};

export default AdMarketplaceAds;


